module.exports = __webpack_public_path__ + "487035254e7a2600a2c8cfefc71178ab.svg";